// extracted by mini-css-extract-plugin
export default {"mainReviewsWrapper":"MJ-z"};